// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scanner-wrapper-container {\n  max-width: 500px;\n  padding: 0px;\n  margin-bottom: 10px;\n}\n@media (min-width: 600px) {\n.scanner-wrapper-container {\n    padding-top: 20px;\n}\n}\n.scanner-wrapper-container .switch-message {\n  margin-top: 3px;\n  width: 100%;\n  text-align: center;\n  text-decoration: underline;\n  color: var(--v-primary-base);\n  cursor: pointer;\n  font-size: 12px;\n}\n.scanner-wrapper-container .switch-message.manual {\n  margin-top: 0px;\n}", ""]);
// Exports
module.exports = exports;
